import {literal, type, TypeOf} from 'io-ts';

export const SuccessResponseSchema = type({
    status: literal('OK'),
});
export type SuccessResponseSchema = TypeOf<typeof SuccessResponseSchema>;
